import {BehaviorSubject} from "rxjs";
import {hookFromSubject, promiseToSubject, ResponseSubjectState} from "./index";
import {Configuration, TemplateApi, TemplateCreateEditDto, TemplateParameterDto} from "../generated-api";
import {getCustomHeaders} from "./user";

export const LINE_HEIGHT = 54;

const {REACT_APP_API_DOMAIN} = process.env;
const templateApi = new TemplateApi(new Configuration({basePath: REACT_APP_API_DOMAIN, getHeaders: getCustomHeaders}));

export const templateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useTemplate = hookFromSubject(templateSubject);
export const getTemplate = (withAllTemplates: boolean) =>
    promiseToSubject(templateApi.apiTemplateGet({withAllSelection: withAllTemplates}), templateSubject);

export const templateCreateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useTemplateCreate = hookFromSubject(templateCreateSubject);
export const createTemplate = (body?: TemplateCreateEditDto) =>
    promiseToSubject(templateApi.apiTemplatePost(body), templateCreateSubject);

export const templateGuidSubject = new BehaviorSubject(new ResponseSubjectState());
export const useTemplateGuid = hookFromSubject(templateGuidSubject);
export const getTemplateGuid = (guid: string, suppressErrors?: boolean) =>
    promiseToSubject(templateApi.apiTemplateGuidGet({guid}), templateGuidSubject, {suppressErrors: suppressErrors});

export const updateTemplateGuid = (guid: string, body?: TemplateCreateEditDto) =>
    promiseToSubject(templateApi.apiTemplateGuidPut({guid}, body), templateGuidSubject);

export const templateGuidDeleteSubject = new BehaviorSubject(new ResponseSubjectState());
export const useTemplateGuidDelete = hookFromSubject(templateGuidDeleteSubject);
export const deleteTemplateGuid = (guid: string) =>
    promiseToSubject(templateApi.apiTemplateGuidDelete({guid}), templateGuidDeleteSubject);


export class TemplateParameterDrag {
    constructor(public item?: any, public index: number = 0, public startY: number = 0, public height: number = 0, public offset: number = 0) {
        this.item = item;
        this.index = index;
        this.startY = startY;
        this.height = height || LINE_HEIGHT;
        this.offset = offset;
    }
}

export const templateParameterDragSubject = new BehaviorSubject(new TemplateParameterDrag());
export const useTemplateParameterDrag = hookFromSubject(templateParameterDragSubject);

export const templateParametersSubject = new BehaviorSubject<TemplateParameterDto[]>([]);
export const useTemplateParameters = hookFromSubject(templateParametersSubject);
